export default function getProviderTypeFromAddProviderRedirectUrl(urlParameters) {
    var providerType = urlParameters.provider
        ? parseInt(urlParameters.provider)
        : null;
    if (!providerType && urlParameters.state) {
        // This happens only in case of GDrive
        var stateDict = JSON.parse(urlParameters.state);
        if (stateDict) {
            providerType = stateDict.provider ? parseInt(stateDict.provider) : null;
        }
    }
    return providerType;
}
//# sourceMappingURL=getProviderTypeFromAddProviderRedirectUrl.js.map